import { useSelector } from 'react-redux';
import { RootState } from '../store/rootStore';

const useOrganization = () => {
  return useSelector((state: RootState) => state.accesss.organization.data?.info);
};

export default useOrganization;
